/**
 * 模組頁面代碼 : 1420-UI-01
 * 頁面說明 : 機器分配管理資料頁面
 * @module modules/machine/components/MachineAssignmentPage
 */

// ----- import from npm modules -----
import React from 'react';

// ----- import from base libraries -----

import {useEffect, useState, useRef} from 'react';
import {showMessage} from 'web/utils/modalHelper';
import {BaseComponent} from 'web/components/BaseComponent';
import enumList from 'web/utils/enumList';
import {useDispatch} from 'react-redux';
import {useMachineAssignment} from '../hooks/useMachineAssignment';

const MachineAssignmentPage = (props) => {
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const {onBatchHandle, needMachineAssignmentLoad, toggleMachineAddModal, toggleMachineEditModal, setNeedMachineLoad} = props;
  const [searchCustomerName, setSearchCustomerName] = useState('');
  const [searchMachineType, setSearchMachineType] = useState('');
  const [searchDeliveryCode, setSearchDeliveryCode] = useState('');
  const [searchMachineSerialNumber, setSearchMachineSerialNumber] = useState('');
  const tableRef = useRef(null);

  const {machineAssignmentList, getMachineAssignmentList, onBatch} = useMachineAssignment(dispatch, showMessage, onBatchHandle, baseComponent);

  useEffect(() => {
    baseComponent.checkPermission(enumList.moduleEnums.customer, enumList.accessModeEnums.read);
    getMachineList(searchCustomerName, searchDeliveryCode, searchMachineSerialNumber, searchMachineType);
    setNeedMachineLoad(false);
  }, [needMachineAssignmentLoad]);

  useEffect(() => {
    const handleClick = (event) => {
      const button = event.target.closest('.btn');
      if (button && button.id.startsWith('edit-customer-')) {
        toggleMachineEditModal(true, machineList[parseInt(button.id.split('-')[2])]);
      }
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-customer-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked ? enumList.alertModalModeEnums.enable : enumList.alertModalModeEnums.disable;
        const updateMachine = machineList[index];
        if (updateMachine) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updateMachine.customerName} ] 的資料`;
          } else {
            message = `停用 [ ${updateMachine.customerName} ] 的資料`;
          }
          onBatchHandle(mode, message, [updateMachine.customerCode]);
        } else {
          console.log('No case found at index:', index);
        }
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [machineList]);

  const handleSearch = (e) => {
    e.preventDefault();
    const searchForm = new FormData(e.target);
    const customerName = searchForm.get('searchCustomerName');
    const deliveryCode = searchForm.get('searchDeliveryCode');
    const machineSerialNumber = searchForm.get('searchMachineSerialNumber');
    const machineTypeId = searchForm.get('searchMachineType');

    getMachineAssignmentList(customerName, deliveryCode, machineSerialNumber, machineTypeId);
  };

  const onNewDepartment = () => {
    //   this.props.onNewElevator();
  };

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg className="nav__icon nav__icon--breadcrumb me-3" aria-hidden="true">
              <use href="#ico-home-line"></use>
            </svg>
            基本資料
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            機器分配管理資料
          </li>
        </ol>
      </nav>
      <h4>機器分配管理資料</h4>
      <div className="datatable__search">
        <form className="d-flex gap-2 align-items-end needs-validation" noValidate onSubmit={handleSearch}><div className="flex-fill w-100">
          <label htmlFor="searchCustomerName" className="form-label">
            客戶名稱
          </label>
          <input
            className="form-control form-control-sm"
            id="searchCustomerName"
            name="searchCustomerName"
            value={searchCustomerName}
            onChange={(e) => setSearchCustomerName(e.target.value)}
            required
          />
        </div>
        <div className="flex-fill w-100">
          <label htmlFor="searchDeliveryCode" className="form-label">
            交機編號
          </label>
          <input
            className="form-control form-control-sm"
            id="searchDeliveryCode"
            name="searchDeliveryCode"
            value={searchDeliveryCode}
            onChange={(e) => setSearchDeliveryCode(e.target.value)}
            required
          />
        </div>
        <div className="flex-fill w-100">
          <label htmlFor="searchMachineSerialNumber" className="form-label">
            機械番號
          </label>
          <input
            type="text"
            className="form-control form-control-sm"
            id="searchMachineSerialNumber"
            name="searchMachineSerialNumber"
            value={searchMachineSerialNumber}
            onChange={(e) => setSearchMachineSerialNumber(e.target.value)}
            required
          />
        </div>
        <div className="flex-fill w-100">
          <label htmlFor="searchMachineType" className="form-label">
            機器種類
          </label>
          <select
            className="form-select form-select-sm"
            id="searchMachineType"
            name="searchMachineType"
            onChange={(e) => setSearchMachineType(e.target.value)}
            required
          >
            <option disabled value="">
              請選擇
            </option>
            <option value="0">全部</option>
            {Object.entries(enumList.machineTypes).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <button className="btn btn-primary" type="submit">
            <svg className="btn__icon" aria-hidden="true">
              <use href="#ico-search"></use>
            </svg>
          </button>
        </div>
        </form>
      </div>
      <div className="datatable__tool">
        <div className="d-flex align-items-center gap-2">
          <div className="datatable__tool__label">
            多筆選擇
            <div id="checked-count-display"></div>
          </div>
          {baseComponent.checkPermission(enumList.moduleEnums.customer, enumList.accessModeEnums.delete) && (
            <div className="btn-group btn-group-sm" role="group" aria-label="">
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchEnable"
                onClick={() => onBatch(enumList.alertModalModeEnums.enable)}
              >
                啟用
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchDisable"
                onClick={() => onBatch(enumList.alertModalModeEnums.disable)}
              >
                停用
              </button>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          {baseComponent.checkPermission(enumList.moduleEnums.customer, enumList.accessModeEnums.create) && (
            <button type="button" className="btn btn-sm btn-primary" id="modalElevatorBtnNew" onClick={toggleMachineAddModal}>
              <svg className="btn__icon me-2" aria-hidden="true">
                <use href="#ico-plus-square"></use>
              </svg>
              新增
            </button>
          )}
        </div>
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table id="datatable__machineList" className="display table table-hover align-middle nowrap"></table>
      </div>
    </section>
  );
};

export default MachineAssignmentPage;
